import { render, staticRenderFns } from "./PurchaseTypesForm.vue?vue&type=template&id=1c3392a6&"
import script from "./PurchaseTypesForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports